import React from 'react';
import { F90N } from '../../../services/p9209Api';
import { dateToInput, inputToDate } from '../helpers';

interface Tab1Props {
  formData: Partial<F90N>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof F90N) => F90N[keyof F90N];
  setField: (key: keyof F90N, value: F90N[keyof F90N]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
  isFieldDisabled: (key: string) => boolean;
  getFieldError: (field: string) => string | undefined;
}

const Tab1BasicInfo: React.FC<Tab1Props> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName, isFieldDisabled, getFieldError,
}) => {
  return (
    <div className="tab-content-inner">
      <div className="section-title">留職停薪申請資料</div>
      <div className="form-grid form-grid-4col">
        {/* 員工代號 (alwaysDisabled) */}
        <label>員工代號</label>
        <div className="lookup-field">
          <input
            value={String(getField('f90n_11') || '')}
            disabled
            readOnly
            maxLength={8}
          />
          <span className="lookup-name">{names.employee || ''}</span>
        </div>

        {/* 停職開始日 (required, editable) */}
        <label>停職開始日</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90n_14') as string | null)}
            onChange={e => setField('f90n_14', inputToDate(e.target.value))}
            disabled={isFieldDisabled('f90n_14')}
            className={getFieldError('f90n_14') ? 'field-error' : ''}
          />
          {getFieldError('f90n_14') && (
            <div className="field-error-text">{getFieldError('f90n_14')}</div>
          )}
        </div>

        {/* 部門 (alwaysDisabled) */}
        <label>部門</label>
        <div className="lookup-field">
          <input
            value={String(getField('f90n_21') || '')}
            disabled
            readOnly
            maxLength={4}
          />
          <span className="lookup-name">{names.department || ''}</span>
        </div>

        {/* 停職結束日 (required, editable) */}
        <label>停職結束日</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90n_15') as string | null)}
            onChange={e => setField('f90n_15', inputToDate(e.target.value))}
            disabled={isFieldDisabled('f90n_15')}
            className={getFieldError('f90n_15') ? 'field-error' : ''}
          />
          {getFieldError('f90n_15') && (
            <div className="field-error-text">{getFieldError('f90n_15')}</div>
          )}
        </div>

        {/* 職稱 (alwaysDisabled) */}
        <label>職稱</label>
        <div className="lookup-field">
          <input
            value={String(getField('f90n_22') || '')}
            disabled
            readOnly
            maxLength={4}
          />
          <span className="lookup-name">{names.position || ''}</span>
        </div>

        {/* 到職日 (alwaysDisabled) */}
        <label>到職日</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90n_23') as string | null)}
            disabled
            readOnly
          />
        </div>

        {/* 申請日期 (alwaysDisabled) */}
        <label>申請日期</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90n_12') as string | null)}
            disabled
            readOnly
          />
        </div>

        {/* Empty spacer for grid alignment */}
        <div />
        <div />
      </div>

      {/* 停職說明 (editbox — textarea, editable) */}
      <div className="form-grid form-grid-2col" style={{ marginTop: 12 }}>
        <label>停職說明</label>
        <div>
          <textarea
            value={String(getField('f90n_13') || '')}
            onChange={e => setField('f90n_13', e.target.value)}
            disabled={isFieldDisabled('f90n_13')}
            rows={5}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </div>
  );
});

Tab1BasicInfo.displayName = 'Tab1BasicInfo';
export default Tab1BasicInfo;
